import { FC, Fragment } from 'react';
import { PackageDetails } from 'ts/package/interfaces/PackageDetails';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { getTextAlignStyle, checkAHAVI } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface ItineraryDetailsProps {
  dealModel: PackageDetails;
}

const ItineraryDetails: FC<ItineraryDetailsProps> = ({ dealModel }) => {
  const [t] = useTranslation();
  const { tourData } = dealModel.info;
  const { countries, itineraries } = dealModel.additionalInfo;

  return (
    <Fragment>
      {!!tourData && (
        <div className="default-shadow flight-details-item package-itinerary">
          <div
            className="title-underline text-lg mb-15 flex-between"
            style={{ flexDirection: checkAHAVI(tourData.title) ? 'row-reverse' : 'row' }}
          >
            <span>{tourData.title || t('tour.tour')}</span>
            {!!tourData.link && (
              <Tooltip
                children={
                  <a href={tourData.link} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faFileLines as any} />
                  </a>
                }
                content={tourData.link}
              />
            )}
          </div>
          <div className="subtitles">
            <div className="subtitle">
              <span>{t('package.country')} </span>
              <span className="text-bold">
                {(countries.length && countries[0].description) || tourData.country}
              </span>
            </div>
            <div className="subtitle">
              <span>{t('hotel.nights_up')} </span>
              <span className="text-bold">{tourData.nights}</span>
            </div>
            <div className="subtitle">
              <span>{t('package.language')} </span>
              <span className="text-bold">{tourData.lang}</span>
            </div>
          </div>
          {!!tourData.description && (
            <div
              className="subtitles text-sm mt-10"
              style={getTextAlignStyle(tourData.description)}
            >
              {tourData.description}
            </div>
          )}
          <div className="content">
            {itineraries?.map((item, index) => (
              <div key={index} className="mt-10 content-row">
                <div className="text-bold mb-10" style={getTextAlignStyle(item.description)}>
                  <span className="text-contrast mr-5">
                    {t('day')} {item.day}
                  </span>
                  <span> {item.description}</span>
                  <span className="text-light">({item.boardDesc})</span>
                </div>
                <div className="lh" style={getTextAlignStyle(item.description2)}>
                  {item.description2}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(ItineraryDetails, 'ItineraryDetails');
